import { Avatar, Text } from '@hhgtech/hhg-components/mantine'
import { Flex } from '@mantine/core'
import { forwardRef } from 'react'

interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
  icon: string
  label: string
  value: string
}

export const Item = forwardRef<HTMLDivElement, ItemProps>(
  ({ icon, label, value, ...others }: ItemProps, ref) => (
    <div ref={ref} {...others}>
      <Flex align={'center'} gap={8}>
        <Avatar size={20} src={icon} />
        <Text size="sm" className="text">
          {label}
        </Text>
      </Flex>
    </div>
  ),
)
